// Central config for order sub-status flows.
// Each area lists its allowed values with label + badge color class.
// Roles allowed to change each area are enforced in UI (backend accepts any authed user).

export const FABRICACION = [
  { value: "pendiente", label: "Pendiente", cls: "bg-zinc-200 text-zinc-800" },
  { value: "pendiente_material", label: "Pendiente material", cls: "bg-orange-100 text-orange-900" },
  { value: "en_proceso", label: "En proceso", cls: "bg-amber-100 text-amber-900" },
  { value: "parcial", label: "Parcial", cls: "bg-yellow-100 text-yellow-900" },
  { value: "listo", label: "Listo", cls: "bg-emerald-100 text-emerald-900" },
];

export const EMPAQUE = [
  { value: "pendiente", label: "Pendiente", cls: "bg-zinc-200 text-zinc-800" },
  { value: "empacado", label: "Empacado", cls: "bg-emerald-100 text-emerald-900" },
  { value: "otro_dia", label: "Otro día", cls: "bg-yellow-100 text-yellow-900" },
];

export const ENTREGA = [
  { value: "pendiente", label: "Pendiente", cls: "bg-zinc-200 text-zinc-800" },
  { value: "pendiente_preparar", label: "Pendiente de preparar", cls: "bg-slate-200 text-slate-800" },
  { value: "pendiente_generar_guia", label: "Pendiente de generar guía", cls: "bg-cyan-100 text-cyan-900" },
  { value: "por_recolectar", label: "Por recolectar", cls: "bg-yellow-100 text-yellow-900" },
  { value: "en_ruta", label: "En ruta", cls: "bg-blue-100 text-blue-900" },
  { value: "en_bodega", label: "En bodega", cls: "bg-indigo-100 text-indigo-900" },
  { value: "danado", label: "Dañado", cls: "bg-red-100 text-red-900" },
  { value: "no_recibido", label: "No recibido", cls: "bg-orange-100 text-orange-900" },
  { value: "entregado", label: "Entregado", cls: "bg-emerald-100 text-emerald-900" },
  { value: "colocado_agencia", label: "Colocado en Cargo Expreso", cls: "bg-emerald-600 text-white" },
  { value: "fallido", label: "Fallido", cls: "bg-red-100 text-red-900" },
];

export const FACTURACION = [
  { value: "pendiente_facturar", label: "Pendiente", cls: "bg-zinc-200 text-zinc-800" },
  { value: "parcial", label: "Parcial", cls: "bg-yellow-100 text-yellow-900" },
  { value: "facturado", label: "Facturado", cls: "bg-emerald-100 text-emerald-900" },
  { value: "falta_pago", label: "Falta pago", cls: "bg-orange-100 text-orange-900" },
  { value: "pagado", label: "Pagado", cls: "bg-emerald-100 text-emerald-900" },
];

export function labelFor(list, value) {
  const opt = list.find((o) => o.value === value);
  return opt ? opt.label : (value || "—");
}

export function classFor(list, value) {
  const opt = list.find((o) => o.value === value);
  return opt ? opt.cls : "bg-zinc-100 text-zinc-500";
}
